import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const MontoRentaBrutaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Renta Bruta' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='montoRentaBruta'>
          {({ field }) => <Form.InputText {...field} id='input-montoRentaBruta' isInvalid={iError && iTouched} disabled={fIsSubmitting} />}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoRentaBrutaFormGroup)
